module.exports = __webpack_public_path__ + "Chrome-52c5a47bc984e1b95921a40b7c17cfd1.png";


//////////////////
// WEBPACK FOOTER
// ./assets/browser-icons/Chrome.png
// module id = 1128
// module chunks = 0 1